<template>
  <div>
    <div v-if="currentFile" class="files-preview-info">
      <ul class="list-group">
        <li class="list-group-item text-break">
          {{ currentFile.fileName }}
        </li>
        <li class="list-group-item">
          <download-file :currentFile="currentFile" :key="JSON.stringify(currentFile)" />
        </li>
      </ul>
    </div>
    <light-box ref="lightbox" :images="lightBoxMedia" :show-light-box="false" />
  </div>
</template>

<script>
import Vue from 'vue';
import LightBox from 'vue-image-lightbox';

export default {
  components: {
    LightBox
  },
  data() {
    return {
      mediaFiles: [],
      currentFileIndex: null
    };
  },
  computed: {
    currentFile() {
      return this.mediaFiles[this.currentFileIndex];
    },
    lightBoxMedia() {
      return this.mediaFiles
        .map((file) => {
          const src = file.fileThumbLocation || file.fileLocation || file.url;
          return { src, thumb: src, ...file };
        })
        .filter((image) => !!image.src);
    }
  },
  mounted() {
    Vue.prototype.$previewFiles = this.previewFiles;
    this.enableWatchLightBoxOn();
    this.enableWatchLightBoxSelect();
  },
  methods: {
    previewFiles(files, index) {
      this.currentFileIndex = index;
      this.mediaFiles = files;
      this.$refs.lightbox.showImage(index);
    },
    enableWatchLightBoxOn() {
      this.$watch(
        () => this.$refs.lightbox.lightBoxOn,
        (state) => {
          if (!state) {
            this.mediaFiles = [];
          }
        }
      );
    },
    enableWatchLightBoxSelect() {
      this.$watch(
        () => this.$refs.lightbox.select,
        (index) => {
          this.currentFileIndex = index;
        }
      );
    }
  }
};
</script>
